import React from 'react'
import { Container, Grid } from '@material-ui/core'
import getStringsBasedLang from '../../strings/get_strings'
import AboutWebImgs from './about_web_imgs'
import Layout from '../layout/layout'


export default function AboutWebApp() {
    const lang = localStorage.getItem("lang")
    return (
        <Layout>
            <div className={`mb-40 md:px-16 mt-56 ${lang === 'en' ? 'englishIranSans' : ''}`}>
                <div className="gradient_blue_background" />
                <Container>
                    <div className="flex flex-col justify-center items-center xs:mt-20 sm:mt-20 md:mt-56 lg:mt-56">
                        <h3 className="primary_color font-bold xs:text-sm sm:text-sm md:text-2xl lg:text-3xl">{getStringsBasedLang("aboutSystem_desTitle")}</h3>
                        <h1 className="secondry_color text-xs">{getStringsBasedLang("aboutSystem_Property")}</h1>
                        {/*   <img className="mt-10 xs:w-32" src={require('../../assets/icons/logo_main_other.svg').default} alt="Icon" /> */}
                        <p className="primary_color mt-5 w-4/6 xs:text-xs sm:text-sm md:text-base lg:text-base text-justify">{getStringsBasedLang("aboutSystem_descriptoin")}</p>
                    </div>
                    <Grid container spacing={3}>
                        <Grid md={6} item>
                            <AboutWebImgs img="malware" title={getStringsBasedLang("aboutApp_Multiav")} subTitle={getStringsBasedLang("aboutApp_MultiavDes")} />
                        </Grid>
                        {/* <Grid md={6} item>
                            <AboutWebImgs img="sandbox" title={strings.aboutApp_Sandbox} subTitle={strings.aboutApp_SandboxDes} />
                        </Grid> */}
                        <Grid md={6} item>
                            <AboutWebImgs img="vulnerability_identification" title={getStringsBasedLang("aboutApp_configurationAnalysis")} subTitle={getStringsBasedLang("aboutApp_configurationAnalysisDes")} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid md={6} item>
                            <AboutWebImgs img="configuration_analysis" title={getStringsBasedLang("aboutApp_vulnerabilityIdentification")} subTitle={getStringsBasedLang("aboutApp_vulnerabilityIdentificationDes")} />
                        </Grid>
                        <Grid md={6} item>
                            <AboutWebImgs img="generate_PDF_output" title={getStringsBasedLang("aboutApp_pdf")} subTitle={getStringsBasedLang("aboutApp_pdfDes")} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid md={6} item>
                            <AboutWebImgs img="rest_api" title={getStringsBasedLang("aboutApp_restApi")} subTitle={getStringsBasedLang("aboutApp_restApiDes")} />
                        </Grid>
                        <Grid md={6} item>
                            <AboutWebImgs img="provide_solution" title={getStringsBasedLang("aboutApp_provideSolution")} subTitle={getStringsBasedLang("aboutApp_provideSolutionDes")} />
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </Layout>
    )
}
